import { render, staticRenderFns } from "./AreaTree.vue?vue&type=template&id=e8683554&scoped=true"
import script from "./AreaTree.vue?vue&type=script&lang=js"
export * from "./AreaTree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8683554",
  null
  
)

/* custom blocks */
import block0 from "./AreaTree.vue?vue&type=custom&index=0&blockType=vue-filename-injector"
if (typeof block0 === 'function') block0(component)

export default component.exports